import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import cx from 'classnames'
import PaymentHistory from './PaymentHistory'
import PaymentTariffs from './PaymentTariffs'
import { declOfNum } from '../../utils/Utils'

const styles = theme => ({
  paymentInfoList: {
    listStyleType: 'none',
    fontSize: 12,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: 'rgba(0, 0, 0, 0.65)',
    '& li': {
      marginBottom: 16,
    },
    '& a': {
      pointerEvents: 'none',
      cursor: 'default',
      color: '#006fff',
      textDecoration: 'underline',
    },
  },
  paymentNext: {
    display: 'block',
    whiteSpace: 'pre-line',
  },
  paymentStatistics: {
    display: 'block',
  },
  lastPayment: {
    color: 'rgba(0, 0, 0, 0.65)',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: 'normal',
    fontStretch: 'normal',
    letterSpacing: 'normal',
    listStyleType: 'none',
    marginBottom: 16,
  },
  lastPaymentBtns: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 'auto',
  },
  paymentRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 16,
  },
  lastPaymentError: {
    display: 'block',
    color: '#ff4e44',
  },
})

export class PaymentInfo extends Component {
  state = {
    statistics: window.state.statistics,
    lastPayment: window.state.lastPayment,
    nextPayment: window.state.nextPayment,
  }
  render() {
    const { classes } = this.props
    const {
      statistics: { sessionsFor30Days },
      nextPayment: { date, amount, otherAmount, totalAmount },
      lastPayment,
    } = this.state

    const last_payment = lastPayment ? (
      <div
        className={cx(classes.lastPayment, {
          [classes.lastPaymentError]: lastPayment && !lastPayment.status,
        })}
      >
        <span className={classes.paymentNext}>
          {`Последний платеж: \n ${lastPayment.date}`}
        </span>
        <span>
          {lastPayment.status ? `✔ ` : `✗ `} {` ${lastPayment.amount} руб.`}
        </span>
        <span className={classes.lastPaymentError}>{lastPayment.error}</span>
      </div>
    ) : null

    const btnGroup = (
      <div className={classes.lastPaymentBtns}>
        <PaymentHistory />
        <PaymentTariffs />
      </div>
    )

    return (
      <Fragment>
        <div className={classes.paymentRow}>
          {lastPayment && last_payment}
          {btnGroup}
        </div>
        <ul className={classes.paymentInfoList}>
          <li>
            <span
              className={classes.paymentNext}
            >{`Следующий платеж:\n ${date}`}</span>
            {otherAmount == 0 ? (
              <span>{`Ожидаемая сумма следующего платежа - ${amount} руб. (рассчитано на основе посещаемости сайта).`}</span>
            ) : (
              <div>
                <span>{`Ожидаемая сумма следующего платежа - ${amount} руб. - базовый + ${otherAmount} руб. - дополнительный функционал (рассчитано на основе посещаемости сайта).`}</span>
                <br />
                <span>Итого: {totalAmount} руб.</span>
              </div>
            )}
          </li>

          <li>
            <span>Ваша текущая статистика: </span>
            {sessionsFor30Days !== '' ? (
              <span>
                {`${sessionsFor30Days} `}
                {declOfNum(sessionsFor30Days, ['сеанс', 'сеанса', 'сеансов'])}
                {` сайта за прошедшие 30 дней`}
              </span>
            ) : (
              <span className={classes.paymentStatistics}>
                Данные будут получены в течение 24 часов
              </span>
            )}
          </li>
          <li>Оплата за пользование сервисом происходит автоматически перед началом нового месяца</li>
        </ul>
      </Fragment>
    )
  }
}

export default withStyles(styles)(PaymentInfo)
